import { initializeDBL } from 'dibs-buyer-layout/src/entries/index';
import { buyRespRootQuery } from '../../queries/buyRespRoot';
import { BuyRespLayout } from '../../buy/BuyRespLayout';
import { createEntry } from '../createEntry';

import { defaultReducers, actionSanitizer } from '../../reducers/reducerUtils';
import { sbSharedReducers } from '../../reducers/sbSharedReducers';
const options = {
    reducers: {
        ...defaultReducers,
        ...sbSharedReducers,
    },
    actionSanitizer,
};

initializeDBL(options).then(({ store }) => {
    createEntry({
        Container: BuyRespLayout,
        store,
        query: buyRespRootQuery,
    });
});
